import { CommanderThunkAction } from '@mews-commander/types';
import { IntegrationDataType } from '@mews-commander/data-access';
import { getCurrentEnterpriseId, getStrictCurrentEnterpriseId } from '@mews-commander/core';
import {
    getBizzonApplicationId,
    getDigitalKeyApplicationId,
    getExpediaApplicationId,
    getFlexkeepingApplicationId,
} from './selectors';

export const showMarketplace =
    (applicationId?: string): CommanderThunkAction =>
    (dispatch, getState, { navigate }) => {
        const enterpriseId = getCurrentEnterpriseId();
        const search = {
            OwnerId: enterpriseId,
            ...(applicationId ? { ApplicationId: applicationId } : {}),
        };

        void navigate({
            to: '/$currentEnterpriseId/EnterpriseIntegration/Marketplace',
            params: { currentEnterpriseId: getStrictCurrentEnterpriseId() },
            search,
        });
    };

export const showBizzonApplication = (): CommanderThunkAction => (dispatch, getState) => {
    const bizzonApplicationId = getBizzonApplicationId(getState());

    dispatch(showMarketplace(bizzonApplicationId));
};

export const showExpediaApplication = (): CommanderThunkAction => (dispatch, getState) => {
    const expediaApplicationId = getExpediaApplicationId(getState());

    dispatch(showMarketplace(expediaApplicationId));
};
export const showDigitalKeyApplication = (): CommanderThunkAction => (dispatch, getState) => {
    const digitalKeyApplicationId = getDigitalKeyApplicationId(getState());

    dispatch(showMarketplace(digitalKeyApplicationId));
};

export const showTerminalOrderApplication = () => showMarketplace(IntegrationDataType.StripePaymentTerminalIntegration);

export const showFlexkeepingApplication = (): CommanderThunkAction => (dispatch, getState) => {
    const flexkeepingApplicationId = getFlexkeepingApplicationId(getState());

    dispatch(showMarketplace(flexkeepingApplicationId));
};

export const searchMarketplace =
    (searchTerm: string): CommanderThunkAction =>
    (dispatch, getState, { navigate }) => {
        const enterpriseId = getCurrentEnterpriseId();
        const search = {
            OwnerId: enterpriseId,
            SearchTerm: searchTerm,
        };

        void navigate({
            to: '/$currentEnterpriseId/EnterpriseIntegration/Marketplace',
            params: { currentEnterpriseId: getStrictCurrentEnterpriseId() },
            search,
        });
    };
